import { render, staticRenderFns } from "./AllInactiveClients.vue?vue&type=template&id=21a43fd0&"
import script from "./AllInactiveClients.vue?vue&type=script&lang=js&"
export * from "./AllInactiveClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports